const runtimeConfig =
  typeof window !== 'undefined' && window.__APP_CONFIG__
    ? window.__APP_CONFIG__
    : {};

const processEnv =
  typeof process !== 'undefined' && process.env
    ? process.env
    : {};

const getFirstNonEmptyString = (...values) =>
  values.find((value) => typeof value === 'string' && value.trim().length > 0) || '';

const normalizeBaseUrl = (value) => value.replace(/\/+$/, '');

export const API_URL = normalizeBaseUrl(
  getFirstNonEmptyString(
    runtimeConfig.VITE_API_URL,
    runtimeConfig.REACT_APP_API_URL,
    processEnv.VITE_API_URL,
    processEnv.REACT_APP_API_URL
  )
);

export const ASSET_BASE_URL = API_URL.replace(/\/api$/i, '');

export const buildApiUrl = (path = '') => {
  if (!path) return API_URL;
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return API_URL ? `${API_URL}${normalizedPath}` : normalizedPath;
};

export const buildAssetUrl = (path = '') => {
  if (!path) return ASSET_BASE_URL;
  if (/^https?:\/\//i.test(path)) return path;

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return ASSET_BASE_URL ? `${ASSET_BASE_URL}${normalizedPath}` : normalizedPath;
};

export const buildUploadUrl = (path = '') => {
  if (!path) return null;

  if (/^https?:\/\//i.test(path)) return path;
  if (path.startsWith('/uploads')) return buildAssetUrl(path);

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return buildAssetUrl(`/uploads${normalizedPath}`);
};
